const defaultPath = "exams";
const defaultPathName =
  defaultPath.charAt(0).toUpperCase() + defaultPath.slice(1);

export const examsRouters = [
  {
    name: `${defaultPathName}Home`,
    path: `/${defaultPath}`,
    component: () => import(`../../views/${defaultPath}/Home.vue`),
  },
  {
    name: `${defaultPathName}Create`,
    path: `/${defaultPath}/create`,
    component: () => import(`../../views/${defaultPath}/Create.vue`),
  },
  {
    name: `${defaultPathName}Update`,
    path: `/${defaultPath}/:id/edit`,
    component: () => import(`../../views/${defaultPath}/Update.vue`),
  },
  {
    name: `${defaultPathName}Detail`,
    path: `/${defaultPath}/:id`,
    component: () => import(`../../views/${defaultPath}/Detail.vue`),
  },
  {
    name: `${defaultPathName}DetailMyExams`,
    path: `/${defaultPath}/:id/detail`,
    component: () => import(`../../views/${defaultPath}/DetailMyExams.vue`),
  },
  {
    name: `${defaultPathName}Solve`,
    path: `/solve/:userId/:id`,
    component: () => import(`../../views/${defaultPath}/Solve.vue`),
  },
  {
    name: `${defaultPathName}Answers`,
    path: `/answers/:userId/:id/:studentId`,
    component: () => import(`../../views/${defaultPath}/Solve.vue`),
  },
  {
    name: `${defaultPathName}List`,
    path: `/${defaultPath}/list`,
    component: () => import(`../../views/${defaultPath}/List.vue`),
  },
  {
    name: `${defaultPathName}Search`,
    path: `/${defaultPath}/search`,
    component: () => import(`../../views/${defaultPath}/Search.vue`),
  },
];
